<template>
  <layout title="Branding">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 !pb-28 max-w-7xl w-full flex items-stretch">
        <sideMenu page="branding" />
        <div class="flex flex-col flex-1 md:ml-8 ml-4">
          <div
            class="font-black text-3xl text-gray-800 inline-block lg:col-span-2 col-span-1"
          >
            Branding
          </div>
          <div
            class="mt-6 bg-white shadow-allArround rounded-xl relative"
            v-if="product && product.private_name.toLowerCase() == 'kyc'"
          >
            <PuSkeleton
              class="h-full w-full z-10 rounded-xl absolute"
              v-if="loading"
            />
            <div class="p-4 text-gray-800">
              <div class="flex flex-col">
                <div>
                  <p>Identity verification UI customization</p>
                </div>
                <div class="bg-gray-200 my-4 h-0.5"></div>
                <div class="max-w-xs">
                  <form
                    role="form"
                    @submit.prevent="saveSettings"
                    method="POST"
                  >
                    <div>
                      <label
                        for="colorPick"
                        class="flex gap-1 text-sm font-medium leading-5 text-gray-700 required"
                      >
                        Primary color
                      </label>
                      <div
                        id="colorPick"
                        class="mt-1 rounded-md shadow-sm relative"
                      >
                        <input
                          type="text"
                          name="color"
                          required
                          class="w-full"
                          v-model="settings.primary_color"
                          @click="openColorPicker()"
                        />
                        <div
                          :style="
                            'top: 7px;right: 8px;background-color:' +
                            settings.primary_color
                          "
                          class="w-7 h-7 rounded-md absolute cursor-pointer"
                          @click="openColorPicker()"
                        ></div>
                        <chrome-picker
                          v-model="settings.primary_color"
                          @input="updateValue"
                          class="absolute z-10"
                          v-show="showColorPicker"
                        />
                      </div>
                    </div>

                    <div class="mt-4">
                      <label
                        class="flex gap-1 text-sm font-medium leading-5 text-gray-700"
                      >
                        Theme
                      </label>
                      <nav
                        class="inline-flex overflow-hidden text-sm border-gray-300 rounded-lg h-10 mt-1"
                        style="border-width: 0.04rem"
                      >
                        <div
                          @click="setTheme('light')"
                          class="px-5 py-3 font-bold focus:outline-none flex justify-center items-center cursor-pointer"
                          :class="
                            settings.theme == 'light'
                              ? 'text-white bg-primary-color'
                              : 'text-gray-600 hover:text-gray-700 bg-white'
                          "
                        >
                          Light
                        </div>
                        <div
                          @click="setTheme('dark')"
                          class="px-5 py-3 font-bold focus:outline-none flex justify-center items-center cursor-pointer"
                          :class="
                            settings.theme == 'dark'
                              ? 'text-white bg-primary-color'
                              : 'text-gray-600 hover:text-gray-700 bg-white'
                          "
                        >
                          Dark
                        </div>
                      </nav>
                    </div>
                    <button type="submit" class="btn-primary mt-6">Save</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative p-4 flex justify-center items-center flex-col text-center"
            v-if="
              loadingProduct ||
              (product && product.private_name.toLowerCase() != 'kyc')
            "
          >
            <PuSkeleton
              class="h-full w-full z-20 rounded-xl absolute"
              v-if="loadingProduct"
            />
            <div
              v-if="
                product &&
                product.private_name.toLowerCase() != 'kyc' &&
                !loadingProduct
              "
            >
              <div>
                Subscribe the Identity Verification plan to unlock the branding
                settings.
              </div>
              <inertia-link
                :href="$route('pricing') + '#products'"
                class="link mt-2"
                >Go to Plans</inertia-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>
  
  <script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/Layout/User/sideMenu.vue"
  );

import { Chrome } from "vue-color";

export default {
  components: {
    layout: layout,
    sideMenu: sideMenu,
    "chrome-picker": Chrome,
  },
  props: ["errors"],
  data() {
    return {
      settings: {
        primary_color: "#492280",
        theme: "light",
      },
      showColorPicker: false,
      loading: true,
      loadingProduct: true,
      product: null,
    };
  },
  mounted() {
    window.addEventListener("click", this.clickOutsideColorPickerToClose);
    this.getProduct();
    this.getBrandSettings();
  },
  beforeDestroyed() {
    window.removeEventListener("click", this.clickOutsideColorPickerToClose);
  },
  methods: {
    getProduct() {
      this.axios
        .get("/user/api/product")
        .then((response) => {
          if (response.data.name) {
            this.product = response.data;
          } else {
            this.product = { private_name: "unset" };
          }
          this.loadingProduct = false;
        })
        .catch(() => {
          this.loadingProduct = false;
        });
    },
    getBrandSettings() {
      this.axios.get("/user/api/brand-settings").then((response) => {
        if (response.data && response.data.settings) {
          this.settings = response.data.settings;
        }
        this.loading = false;
      });
    },
    clickOutsideColorPickerToClose(event) {
      var picker = document.querySelector("#colorPick");
      if (picker != null && !picker.contains(event.target)) {
        this.showColorPicker = false;
      }
    },
    saveSettings() {
      this.$inertia.post("/user/api/store-brand-settings", this.settings, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null)
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
        },
      });
    },
    updateValue(value) {
      this.settings.primary_color = value.hex;
    },
    openColorPicker() {
      this.showColorPicker = true;
    },
    setTheme(option) {
      this.settings.theme = option;
    },
  },
};
</script>